/**
 * Transform layer para el servicio de guardias (Shifts)
 * Normaliza datos entre frontend y backend
 */

/**
 * Transforma los datos de guardias para enviar al backend
 * @param {Object} data - Datos del componente Shifts
 * @param {Array} data.shifts - Array de trabajadores con sus guardias
 * @param {string} data.id_patient - ID del paciente (opcional)
 * @param {string} data.id_dashboard - ID del dashboard
 * @param {Object} data.filter - Filtros adicionales (opcional)
 * @returns {Object} Payload formateado para el backend
 */
export const saveShiftsData = (data) => {
  return {
    tipo: "OPERACION_SAVE_SHIFTS",
    shifts: data.shifts,
    id_patient: data.id_patient,
    id_dashboard: data.id_dashboard,
    filter: data.filter
  };
};

/**
 * Transforma la respuesta del backend al guardar guardias
 * @param {Object} response - Respuesta HTTP del backend
 * @param {Object} response.data - Datos de la respuesta
 * @returns {Object} Datos normalizados para el frontend
 */
export const responseSaveShifts = ({ data = {} }) => {
  return {
    success: data.codigo === "200",
    data: data
  };
};
